// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"oRHGq1h","size-sm":"sL0g7le","sizeSm":"sL0g7le","mobile":"B3palUZ"};